import React, { useState, useEffect } from "react";
import { default as Disclaimer } from "../Disclaimer";
export default function Steps({
  pageJSON,
  simPageNum,
  setIsEmulatorStep,
  emulatorStep,
  setTotalSteps,
  isSingleScreenStep,
  setIsSingleStepScreen,
  page,
  mwidth,
  isAndroid,
}) {
  useEffect(() => {
    if (isSingleScreenStep) {
      setIsSingleStepScreen(false);
    }
    setIsEmulatorStep(true);
    setTotalSteps(pageJSON[simPageNum].content_data.steps.length);
    return () => {
      setIsEmulatorStep(false);
    };
  }, []);

  return (
    <div
      // className="steps-scale"
      style={{
        width: "100%",
        height: "auto",
        marginTop: "62%",
        backgroundColor: pageJSON[simPageNum].content_data.steps[emulatorStep]
          .text
          ? "#fff"
          : "#FFFFFF",
        textAlign: "center",
        maxWidth: "1000px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        transform: "scale(1.3)"
      }}
    >
      <p
        className="body-text"
        style={{
          fontFamily: "LG_Smart_Regular",
          lineHeight: "1.4rem",
        }}
        dangerouslySetInnerHTML={{
          __html: pageJSON[simPageNum].content_data.steps[emulatorStep].text,
        }}
      ></p>
    </div>
  );
}
